import { FC } from "react";
import {
  InputCheckbox,
  InputContainer,
} from "../../../../../components-common/forms";
import { InputNumberInteger } from "@components-common/forms";
import { Form } from "taltech-styleguide";
import { useField } from "formik";

/**
 * Component: InputMeasure
 *
 * This component renders an input section for measuring units. It includes a checkbox to specify if the measure is modular
 * and an input for module size which gets disabled when the modular checkbox is unchecked.
 *
 * Props:
 * @param {string} parentFieldId - The parent field identifier.
 *
 * @returns {JSX.Element} The rendered InputMeasure component.
 */
export const InputMeasure: FC<{ parentFieldId: string }> = ({
  parentFieldId,
}) => {
  const [modularField] = useField(`modular`);
  return (
    <InputContainer title="Measure unit">
      <div className={"w-100"}>
        <InputCheckbox
          id="modular"
          label="Is Modular"
          elementClass="required"
        />
      </div>
      <Form.Group className={"d-flex"}>
        {/* Leave this comment just in case we may need in the future */}
        <div className={"w-100"}>
          <InputNumberInteger
            id={`moduleSize`}
            label="Module size (m)"
            elementClass="required"
            disabled={modularField.value === false}
          />
        </div>
      </Form.Group>
    </InputContainer>
  );
};
